export interface CsvOption {
  key: string;
  label: string;
  icon: string;
}

export interface IntegrationOption {
  key: string;
  label: string;
  icon: string;
  route: string;
}

export interface ScriptOption {
  key: string;
  label: string;
  icon: string;
}

export interface ModuleConfig {
  csvOptions?: CsvOption[];
  integrationOptions?: IntegrationOption[];
  scriptOption?: ScriptOption;
}

export const IMPORT_CONFIG: Record<string, ModuleConfig> = {
  client: {
    csvOptions: [
      { key: 'CLIENT', label: 'Clients', icon: 'ClientLogo' },
      { key: 'REQUESTER', label: 'Requesters', icon: 'Requesters' },
      { key: 'SITE', label: 'Sites', icon: 'Site' },
      { key: 'CLIENTCONTRACT', label: 'Subscriptions', icon: 'Subscriptions' },
      {
        key: 'TECHNICIANSGROUPS',
        label: 'Technicians Groups',
        icon: 'TechnicianGroup'
      }
    ],
    integrationOptions: [
      {
        key: 'quickbooks',
        label: 'QuickBooks',
        icon: 'Quickbooks',
        route: '/onboard/integrations/QUICK_BOOKS_ONLINE'
      },
      {
        key: 'xero',
        label: 'Xero',
        icon: 'XeroBlue',
        route: '/onboard/integrations/XERO'
      },
      {
        key: 'pax8',
        label: 'PAX8',
        icon: 'Pax8',
        route: '/onboard/integrations/PAX8'
      }
    ]
  },
  assets: {
    csvOptions: [{ key: 'UNMONITOR_ASSET', label: 'Assets', icon: 'AssetPC' }]
    // scriptOption: {
    //   key: 'script',
    //   label: 'Assets',
    //   icon: 'ScriptSheet'
    // }
  },
  tickets: {
    csvOptions: [
      { key: 'TICKET', label: 'Tickets', icon: 'TicketOutline' },
      {
        key: 'TICKETCONVERSATIONS',
        label: 'Ticket Conversations',
        icon: 'ReplyBubble'
      },
      {
        key: 'TICKETWORKLOGS',
        label: 'Ticket Worklogs',
        icon: 'Worklog'
      },
      { key: 'TICKETNOTES', label: 'Ticket Notes', icon: 'Notes' }
    ]
  },
  contracts: {
    csvOptions: [
      { key: 'CLIENT', label: 'Clients', icon: 'ClientLogo' },
      { key: 'REQUESTER', label: 'Requesters', icon: 'Requesters' },
      { key: 'SITE', label: 'Sites', icon: 'Site' },
      { key: 'CLIENTCONTRACT', label: 'Subscriptions', icon: 'Subscriptions' },
      {
        key: 'TECHNICIANSGROUPS',
        label: 'Technicians Groups',
        icon: 'TechnicianGroup'
      }
    ],
    integrationOptions: [
      {
        key: 'pax8',
        label: 'PAX8',
        icon: 'Pax8',
        route: '/onboard/integrations/PAX8'
      }
    ]
  },
  contractsClientTab: {
    csvOptions: [
      { key: 'CLIENTCONTRACT', label: 'Subscriptions', icon: 'Subscriptions' }
    ],
    integrationOptions: [
      {
        key: 'pax8',
        label: 'PAX8',
        icon: 'Pax8',
        route: '/onboard/integrations/PAX8'
      }
    ]
  },
  siteClientTab: {
    csvOptions: [{ key: 'SITE', label: 'Sites', icon: 'Site' }]
  },
  serviceItems: {
    csvOptions: [
      { key: 'SERVICEITEM', label: 'Service catalog', icon: 'ServiceCatalog' },
      { key: 'CLIENTCONTRACT', label: 'Subscriptions', icon: 'Subscriptions' }
    ],
    integrationOptions: [
      {
        key: 'quickbooks',
        label: 'QuickBooks',
        icon: 'Quickbooks',
        route: '/onboard/integrations/QUICK_BOOKS_ONLINE'
      },
      {
        key: 'xero',
        label: 'Xero',
        icon: 'XeroBlue',
        route: '/onboard/integrations/XERO'
      },
      {
        key: 'pax8',
        label: 'PAX8',
        icon: 'Pax8',
        route: '/onboard/integrations/PAX8'
      }
    ]
  },
  requesters: {
    csvOptions: [
      { key: 'CLIENT', label: 'Clients', icon: 'ClientLogo' },
      { key: 'REQUESTER', label: 'Requesters', icon: 'Requesters' },
      { key: 'SITE', label: 'Sites', icon: 'Site' }
    ]
  },
  techniciansGroups: {
    csvOptions: [
      {
        key: 'TECHNICIANSGROUPS',
        label: 'Technicians Groups',
        icon: 'TechnicianGroup'
      }
    ]
  }
};
